import { route } from '@/endpoint.flexigo';
import Repository from './repository';

const client = new Repository();

export default {
  /**
   * Get OTP dashboard data
   * @param {Object} params - Query parameters
   * @param {number} params.startDay - Start day (YYYYMMDD format)
   * @param {number} params.endDay - End day (YYYYMMDD format)
   * @param {number} [params.threshold] - Optional threshold value
   * @param {Array<number>} [params.routeIds] - Optional array of route IDs
   * @param {Array<number>} [params.driverIds] - Optional array of driver IDs
   * @returns {Promise} - OTP dashboard data
   */
  async getOtpDashboardData(params) {
    const { startDay, endDay, threshold, routeIds, driverIds, workingTypes } = params;

    const queryParams = {
      startDay,
      endDay,
    };

    // Add optional parameters if provided
    if (threshold !== undefined && threshold !== null) {
      queryParams.threshold = threshold;
    }

    if (routeIds && routeIds.length > 0) {
      queryParams.routeIds = routeIds;
    }

    if (driverIds && driverIds.length > 0) {
      queryParams.driverIds = driverIds;
    }

    if (workingTypes) {
      queryParams.workingTypes = workingTypes;
    }

    const response = await client.instance.get(route.otpDashboardData, {
      params: queryParams,
      paramsSerializer: (paramsToSerialize) => {
        const searchParams = new URLSearchParams();
        Object.keys(paramsToSerialize).forEach((key) => {
          const value = paramsToSerialize[key];
          if (Array.isArray(value)) {
            // Use repeated parameters without array notation: routeIds=1&routeIds=2
            value.forEach((item) => searchParams.append(key, item));
          } else {
            searchParams.append(key, value);
          }
        });
        return searchParams.toString();
      },
    });
    return response.data;
  },

  /**
   * Get routes and drivers by date range
   * @param {Object} params - Query parameters
   * @param {number} params.startDay - Start day (YYYYMMDD format)
   * @param {number} params.endDay - End day (YYYYMMDD format)
   * @returns {Promise} - Routes and drivers data
   */
  async getRoutesDriversByDate(params) {
    const { startDay, endDay } = params;

    const queryParams = {
      startDay,
      endDay,
    };

    const response = await client.get(route.routesDriversByDate, queryParams);
    return response;
  },
};
